var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"card"},[_c('personal-info'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('change-password')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }